// extracted by mini-css-extract-plugin
export default {"baseGridContainer":"styles_baseGridContainer__AVkmM","productsDetailsGridContainer":"styles_productsDetailsGridContainer__PWCSE"};